<template>
    <!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="ModalTitle">Add new SubCategory</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
         
        <form>
            <div v-if="form.id == 0" class="form-group">
                <label for="name">Category Name</label>
                <input v-model="Cname" type="text" class="form-control" id="Catname" placeholder="Category Name" disabled>
            </div>
            <div v-if="form.id != 0" class="form-group">
                                <label>Select Category</label>
                                <select v-model="form.Cid" class="form-control" name="category">
                                    <option v-for="cat in categories" :key="cat.id" :value="cat.id">
                                        {{
                                        cat.name}}
                                    </option>
                                </select>
                            </div>
            <div class="form-group">
                <label for="Subname">Subcategory Name</label>
                <input type="text" class="form-control" id="name" v-model="form.name" placeholder="Subcategory Name" >
                <small v-if="error" class="errorMessage">{{errors.name}}</small>
            </div>
        </form>


      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button v-if="form.id == 0" type="button" class="btn btn-primary" @click="addsub">Add subcategory</button>
        <button v-if="form.id != 0" type="button" class="btn btn-primary" @click="updatesub">Update subcategory</button>
      </div>
    </div>
  </div>
   <div class="vld-parent">
            <loading name="loader" :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="fullPage">
            </loading>
  </div>
</div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
   components: {
            Loading
        },
        props: {
          form:Object,
          id: Number,
          Cname: String
    },
    data(){
      return{
        categories:[],
          fullPage:true,
          isLoading:false,
          error: false,
          errors: {},
          
      }
    },
    created(){
      this.getCategories()
    },
    methods:{
      getCategories(){
        this.axios.get("/admin/shopLocal/category").then(({data}) => ([this.categories = data]));
      },
      addsub(){
        this.error = false;
        this.isLoading = true;
        this.axios.post('/admin/shopLocal/Subcategory', {category:this.form.Cid, name:this.form.name})
        .then(()=>{
          this.isLoading = false;
          this.$swal({
                icon: 'success',
                title: 'Hurray',
                text: 'New subcategory created',
                        })
         $('#exampleModal').modal('hide');
         this.form.name = '';
         this.$emit('reload');
        })
        .catch((resp)=>{
          this.isLoading = false;
          this.error = true;
          this.errors = resp.response.data.errors;
        })
        
      },
      updatesub(){
        this.error = false;
        this.isLoading = true;
        this.axios.patch('/admin/shopLocal/Subcategory/' + this.form.id, {category:this.form.Cid, name:this.form.name})
        .then(()=>{
          this.isLoading = false;
          this.$swal({
                icon: 'success',
                title: 'Hurray',
                text: 'subcategory updated',
                        })
         $('#exampleModal').modal('hide');
         this.form.name = '';
         this.$emit('reload');
        })
        .catch((resp)=>{
          this.isLoading = false;
          this.error = true;
          this.errors = resp.response.data.errors;
        })
        
      }
    }
}
</script>
<style scoped>
  .errorMessage{
    color: red;
  }
</style>